import { render, staticRenderFns } from "./ThgAdminUpdateStatusDialog.vue?vue&type=template&id=9970a202"
import script from "./ThgAdminUpdateStatusDialog.vue?vue&type=script&lang=ts"
export * from "./ThgAdminUpdateStatusDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports